import React from 'react';
import { FiBell } from 'react-icons/fi';

export default function BellButton({count = 0, onClick, className=''}){
  return (
    <button
      aria-label={`Notifiche (${count})`}
      onClick={onClick}
      className={`relative p-2 text-gray-700 hover:text-gray-900 ${className}`}
    >
      <FiBell className="text-xl" />
      {count > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full px-1.5">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}
